import React from "react";
import { Drawer } from "@mantine/core";
import { MOBILE_Z } from "../tokens";
import { SHEET_TRANSITION } from "./MobileSheet";
import styles from "./MobileFullScreen.module.css";

export interface MobileFullScreenProps {
  opened: boolean;
  onClose: () => void;
  /** Labels the dialog. */
  title: string;
  children: React.ReactNode;
}

/**
 * A sheet's nested screen, full screen over the sheet (design handoff
 * "Mobile web": progressive disclosure becomes a full-screen push, no
 * handle). Slides up 460ms cubic-bezier(.32,.72,0,1), easing its 16px top
 * radius to square on arrival. A Mantine Drawer so it owns the scroll lock
 * and focus while open. Escape is routed by the parent sheet's onKeyDown
 * (React events bubble through the portal), so it backs out to the sheet.
 */
export const MobileFullScreen: React.FC<MobileFullScreenProps> = ({
  opened,
  onClose,
  title,
  children,
}) => (
  <Drawer
    opened={opened}
    onClose={onClose}
    position="bottom"
    size="100%"
    withCloseButton={false}
    withOverlay={false}
    closeOnEscape={false}
    zIndex={MOBILE_Z.sheetScreen}
    padding={0}
    transitionProps={SHEET_TRANSITION}
    classNames={{ content: styles.content, body: styles.body }}
    aria-label={title}
  >
    {children}
  </Drawer>
);
